module.exports = __webpack_public_path__ + "img/1535427676.c0272631.jpg";